// extracted by mini-css-extract-plugin
export default {"admin":"Admin_admin__MuXxX","navbar":"Admin_navbar__cmeMh","content":"Admin_content__KKjvh"};